import { createSlice } from "@reduxjs/toolkit";

export const appNotification = createSlice({
  name: "appNotification",
  initialState: {
    value: {
      status: false,
      appBarNotifications: {
        number: 0,
        messages: [],
      },
    },
  },
  reducers: {
    appBarNotifier: (state, action) => {
      state.value.appBarNotifications.number =
        state.value.appBarNotifications.number + 1;
      state.value.appBarNotifications.messages = [
        ...state.value.appBarNotifications.messages,
        action.payload.messageBody,
      ].reverse();
    },
    clearAppBarMessageNotifier: (state, action) => {
      state.value.appBarNotifications.number = 0;
    },
  },
});

export const { appBarNotifier, clearAppBarMessageNotifier } =
  appNotification.actions;

export default appNotification.reducer;
